import { createContext, useMemo } from "react";
import {
  BottleReturnAPI,
  CategoryAPI,
  CusAccountAPI,
  CustomerAPI,
  CustomerFeedbackAPI,
  DamageAPI,
  InvoiceAPI,
  NotificationAPI,
  ProductAPI,
  PromotionAPI,
  PurchaseAPI,
  RoleAPI,
  StaffAPI,
  StockAPI,
  SupplierAPI,
  SupplierFeedbackAPI,
  UserAPI,
  WorkFlowAPI,
  OrdersAPI,
  CartAPI,
  OrderedProductsAPI,
} from "./action";

export const GlobalState = createContext();

export const DataProvider = ({ children }) => {
  const roleAPI = RoleAPI();
  const userAPI = UserAPI();
  const staffAPI = StaffAPI();
  const customerAPI = CustomerAPI();
  const supplierAPI = SupplierAPI();
  const categoryAPI = CategoryAPI();
  const productAPI = ProductAPI();
  const purchaseAPI = PurchaseAPI();
  const workflowAPI = WorkFlowAPI();
  const promotionAPI = PromotionAPI();
  const stockAPI = StockAPI();
  const invoiceAPI = InvoiceAPI();
  const cusAccountAPI = CusAccountAPI();
  const bottleReturnAPI = BottleReturnAPI();
  const damageAPI = DamageAPI();
  const customerFeedbackAPI = CustomerFeedbackAPI();
  const supplierFeedbackAPI = SupplierFeedbackAPI();
  const notificationAPI = NotificationAPI();
  const cartAPI = CartAPI();
  const orderAPI = OrdersAPI();
  const orderedProductsAPI = OrderedProductsAPI();

  const state = useMemo(
    () => ({
      roleAPI,
      userAPI,
      staffAPI,
      customerAPI,
      supplierAPI,
      categoryAPI,
      productAPI,
      purchaseAPI,
      workflowAPI,
      promotionAPI,
      stockAPI,
      invoiceAPI,
      cusAccountAPI,
      bottleReturnAPI,
      damageAPI,
      customerFeedbackAPI,
      supplierFeedbackAPI,
      notificationAPI,
      cartAPI,
      orderAPI,
      orderedProductsAPI,
    }),
    [
      roleAPI,
      userAPI,
      staffAPI,
      customerAPI,
      supplierAPI,
      categoryAPI,
      productAPI,
      purchaseAPI,
      workflowAPI,
      promotionAPI,
      stockAPI,
      invoiceAPI,
      cusAccountAPI,
      bottleReturnAPI,
      damageAPI,
      customerFeedbackAPI,
      supplierFeedbackAPI,
      notificationAPI,
      cartAPI,
      orderAPI,
      orderedProductsAPI,
    ]
  );

  return <GlobalState.Provider value={state}>{children}</GlobalState.Provider>;
};
